import { createStandardAction } from 'typesafe-actions';
import { FeedEventData, MarketNews } from '@tradingblock/types';

export const FEED_CLOSED = `@news/feed/closed`;
export const FEED_ERRORED = `@news/feed/errored`;
export const FEED_CONNECTED = `@news/feed/connected`;
export const feedClosed = createStandardAction(FEED_CLOSED)<FeedEventData>();
export const feedErrored = createStandardAction(FEED_ERRORED)<FeedEventData>();
export const feedConnected = createStandardAction(FEED_CONNECTED)();

export const NewsFeedActions = {
  newsFeedClosed: createStandardAction(FEED_CLOSED)<FeedEventData>(),
  newsFeedErrored: createStandardAction(FEED_ERRORED)<FeedEventData>(),
  newsFeedConnected: createStandardAction(FEED_CONNECTED)(),
};
